export interface TextMessageTemplates {
    welcome: TextMessageTemplate;
    npc: TextMessageTemplate;
    npcOverLimit: TextMessageTemplate;
    npcOrderCreated: TextMessageTemplate;
    refill: TextMessageTemplate;
    rxRequestDenied: TextMessageTemplate;
    outOfNetwork: TextMessageTemplate;
    passwordReset: TextMessageTemplate;
    autorefill: TextMessageTemplate;
    autorefillDelay: TextMessageTemplate;
    transfer: TextMessageTemplate;
    shipping: TextMessageTemplate;
    partialPayment: TextMessageTemplate;
    partialPaymentOverLimit: TextMessageTemplate;
    awaitingInsurance: TextMessageTemplate;
    pharmacyInfo: TextMessageTemplate;
    readyForPickup: TextMessageTemplate;
    deliveryConfirmation: TextMessageTemplate;
    patientAssistanceProgram: TextMessageTemplate;
}

export class TextMessageTemplates {
    constructor(obj?: TextMessageTemplates) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}

export interface TextMessageTemplate {
    active: boolean;
    disabled: boolean;
    template: string;
    tokens: string[];
}

export class TextMessageTemplate {
    constructor(obj?: TextMessageTemplate) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
